// src/components/ScheduleModal/index.js

import React, { useState, useEffect, useContext, useRef } from "react";
import * as XLSX from "xlsx";

import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import getContactDisplayLabel from "../../utils/getContactDisplayLabel";
import {
  ClickAwayListener,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Typography,
} from "@material-ui/core";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { AuthContext } from "../../context/Auth/AuthContext";
import { isArray, capitalize } from "lodash";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import AttachFile from "@material-ui/icons/AttachFile";
import { head } from "lodash";
import ConfirmationModal from "../ConfirmationModal";
import MessageVariablesPicker from "../MessageVariablesPicker";
import useQueues from "../../hooks/useQueues";
import UserStatusIcon from "../UserModal/statusIcon";
import { Facebook, Instagram, WhatsApp, FlashOn } from "@material-ui/icons";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import ValidateContactListModal from "../ValidateContactListModal";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const ScheduleSchema = Yup.object().shape({
  body: Yup.string().nullable(),
  contactId: Yup.number().required("Obrigatório"),
  sendAt: Yup.string().required("Obrigatório"),
  reminderDate: Yup.string().nullable()
});

const ScheduleModal = ({
  open,
  onClose,
  scheduleId,
  contactId,
  cleanContact,
  reload,
  message, // ✅ Nova prop para pre-popular mensagem
  fromMessageInput = false, // ✅ Nova prop para identificar origem
  user
}) => {
  const classes = useStyles();
  const history = useHistory();
  const isMounted = useRef(true);
  const { companyId } = user;
  const isAdmin = user.profile === 'admin';

  const initialState = {
    body: message || "", // ✅ Pre-popular com mensagem se fornecida
    contactId: contactId || "", // ✅ Pre-popular com contactId se fornecido
    sendAt: moment().add(1, "hour").format("YYYY-MM-DDTHH:mm"),
    sentAt: "",
    openTicket: "enabled",
    ticketUserId: user.id,
    queueId: "",
    statusTicket: "open", // ✅ Status baseado na origem
    intervalo: 1,
    valorIntervalo: 0,
    enviarQuantasVezes: 1,
    tipoDias: 4,
    assinar: false,
    // ✅ Novos campos para lembrete
    reminderDate: "",
  };

  const initialContact = {
    id: "",
    name: "",
    channel: "",
  };

  const [schedule, setSchedule] = useState(initialState);
  const [currentContact, setCurrentContact] = useState(initialContact);
  const [contacts, setContacts] = useState([initialContact]);
  const [intervalo, setIntervalo] = useState(1);
  const [tipoDias, setTipoDias] = useState(4);
  const [attachment, setAttachment] = useState(null);
  const attachmentFile = useRef(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const messageInputRef = useRef();
  const [channelFilter, setChannelFilter] = useState("whatsapp");
  const [whatsapps, setWhatsapps] = useState([]);
  const [selectedWhatsapps, setSelectedWhatsapps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [queues, setQueues] = useState([]);
  const [allQueues, setAllQueues] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState(null);
  const { findAll: findAllQueues } = useQueues();
  const [options, setOptions] = useState([]);

  // Estados para template Meta (API Oficial)
  const [templateName, setTemplateName] = useState("");
  const [templateVariables, setTemplateVariables] = useState({});
  const [templateFile, setTemplateFile] = useState(null);
  const templateFileRef = useRef(null);
  const isOficialConnection = whatsapps.find(w => w.id === selectedWhatsapps)?.channel === "whatsapp_oficial";
  const [validateModalOpen, setValidateModalOpen] = useState(false);

  // Estados para quickMessages
  const [quickMessages, setQuickMessages] = useState([]);
  const [filteredQuickMessages, setFilteredQuickMessages] = useState([]);
  const [loadingQuickMessages, setLoadingQuickMessages] = useState(false);
  const [selectedQuickMessage, setSelectedQuickMessage] = useState("");
  const [quickMessageSearch, setQuickMessageSearch] = useState("");
  const [showAllQuickMessages, setShowAllQuickMessages] = useState(false);
  const [quickMessageListOpen, setQuickMessageListOpen] = useState(false);
  const [quickMessageMedia, setQuickMessageMedia] = useState(null);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      const loadQueues = async () => {
        const list = await findAllQueues();
        setAllQueues(list);
        setQueues(list);
      };
      loadQueues();
    }
  }, []);

  // Buscar quickMessages quando o modal abrir
  useEffect(() => {
    if (open && user?.companyId) {
      fetchQuickMessages();
    }
  }, [open, user?.companyId, user?.id]);

  // Filtrar respostas rápidas baseado na busca
  useEffect(() => {
    if (quickMessageSearch.trim() === "" && !showAllQuickMessages) {
      setFilteredQuickMessages([]);
    } else if (quickMessageSearch.trim() === "" && showAllQuickMessages) {
      setFilteredQuickMessages(quickMessages);
    } else {
      const filtered = quickMessages.filter(qm => 
        qm.message.toLowerCase().includes(quickMessageSearch.toLowerCase()) ||
        qm.shortcode.toLowerCase().includes(quickMessageSearch.toLowerCase())
      );
      setFilteredQuickMessages(filtered);
    }
  }, [quickMessageSearch, quickMessages, showAllQuickMessages]);

  const fetchQuickMessages = async () => {
    setLoadingQuickMessages(true);
    try {
      console.log("🔍 Buscando quickMessages com params:", {
        companyId: user?.companyId,
        userId: user?.id,
        isOficial: "false"
      });

      const { data } = await api.get("/quick-messages/list", {
        params: {
          companyId: user?.companyId,
          userId: user?.id,
          isOficial: "false"
        }
      });

      console.log("📋 Resposta da API quickMessages:", data);
      setQuickMessages(data || []);
      setFilteredQuickMessages(data || []);
    } catch (err) {
      console.error("❌ Erro ao buscar respostas rápidas:", err);
      toastError(err);
      setQuickMessages([]);
      setFilteredQuickMessages([]);
    } finally {
      setLoadingQuickMessages(false);
    }
  };

  // Função para baixar mídia da quickMessage
  const downloadQuickMessageMedia = async (mediaPath, mediaName, mediaType) => {
    try {
      // console.log("📎 Baixando mídia da quickMessage:", { mediaPath, mediaName, mediaType });

      // Construir URL correta usando a URL base do backend
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';
      const downloadUrl = `${backendUrl}/public/company${user?.companyId}/quickMessage/${mediaName}`;

      // console.log("🔗 URL de download:", downloadUrl);

      const response = await fetch(downloadUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Erro ao baixar mídia: ${response.status}`);
      }

      const blob = await response.blob();
      const file = new File([blob], mediaName, {
        type: blob.type || getMediaTypeFromExtension(mediaName, mediaType)
      });

      // console.log("✅ Mídia baixada com sucesso:", file);
      return file;
    } catch (err) {
      console.error("❌ Erro ao baixar mídia da quickMessage:", err);
      toastError(err);
      return null;
    }
  };

  // Função auxiliar para determinar o tipo MIME baseado na extensão
  const getMediaTypeFromExtension = (fileName, mediaType) => {
    const extension = fileName.split('.').pop().toLowerCase();

    switch (mediaType) {
      case 'image':
        return `image/${extension === 'jpg' ? 'jpeg' : extension}`;
      case 'audio':
        return `audio/${extension}`;
      case 'video':
        return `video/${extension}`;
      default:
        return 'application/octet-stream';
    }
  };

  useEffect(() => {
    if (!open || !isAdmin) return;
    setLoading(true);
    const fetchUsers = async () => {
      try {
        const { data } = await api.get("/users/");
        setOptions(data.users);
      } catch (err) {
        toastError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, [open, isAdmin]);

  useEffect(() => {
    api
      .get(`/whatsapp/filter`, {
        params: { session: 0 },
      })
      .then(({ data }) => {
        const mappedWhatsapps = data.map((whatsapp) => ({
          ...whatsapp,
          selected: false,
        }));

        setWhatsapps(mappedWhatsapps);
        if (mappedWhatsapps.length && mappedWhatsapps?.length === 1) {
          setSelectedWhatsapps(mappedWhatsapps[0].id);
        }
      });
  }, [currentContact, channelFilter]);

  useEffect(() => {
    if (contactId && contacts.length) {
      const contact = contacts.find((c) => c.id === contactId);
      if (contact) {
        setCurrentContact(contact);
      }
    }
  }, [contactId, contacts]);

  // ✅ MELHORIA: UseEffect otimizado com melhor lógica de inicialização
  useEffect(() => {
    const { companyId } = user;
    if (open) {
      try {
        (async () => {
          // Carregar lista de contatos
          const { data: contactList } = await api.get("/contacts/list", {
            params: { companyId: companyId },
          });

          let customList = contactList.map((c) => ({
            id: c.id,
            name: c.name,
            channel: c.channel,
            number: c.number,
            lid: c.lid,
          }));

          if (isArray(customList)) {
            setContacts([{ id: "", name: "", channel: "" }, ...customList]);
          }

          // ✅ MELHORIA: Lógica de inicialização aprimorada
          if (!scheduleId) {
            // Modal sendo aberto para criar novo agendamento
            const newScheduleState = {
              ...initialState,
              body: message || "", // ✅ Pre-popular mensagem
              contactId: contactId || "", // ✅ Pre-popular contato
            };

            setSchedule(newScheduleState);

            // ✅ MELHORIA: Se contactId foi fornecido, definir contato atual
            if (contactId && customList.length > 0) {
              const foundContact = customList.find((c) => c.id.toString() === contactId.toString());
              if (foundContact) {
                setCurrentContact(foundContact);
                setChannelFilter(foundContact.channel || "whatsapp");
                console.log("✅ Contato auto-selecionado:", foundContact.name);
              }
            }

            return;
          }

          // ✅ Carregamento de agendamento existente (lógica original)
          const { data } = await api.get(`/schedules/${scheduleId}`);
          setSchedule((prevState) => {
            return {
              ...prevState,
              ...data,
              sendAt: moment(data.sendAt).format("YYYY-MM-DDTHH:mm"),
              // ✅ Incluir campos de lembrete no carregamento
              reminderDate: data.reminderDate ? moment(data.reminderDate).format("YYYY-MM-DDTHH:mm") : "",
            };
          });

          console.log("📅 Agendamento carregado:", data);

          if (data.whatsapp) {
            setSelectedWhatsapps(data.whatsapp.id);
          }

          if (data.templateName) setTemplateName(data.templateName);
          if (data.templateVariables) setTemplateVariables(data.templateVariables);

          if (!isAdmin && data.ticketUser) {
            setSelectedUser(data.ticketUser);
          }

          if (data.queueId) {
            setSelectedQueue(data.queueId);
          }

          if (data.intervalo) {
            setIntervalo(data.intervalo);
          }

          if (data.tipoDias) {
            setTipoDias(data.tipoDias);
          }

          setCurrentContact(data.contact);
        })();
      } catch (err) {
        toastError(err);
      }
    }
  }, [scheduleId, contactId, open, user, message, fromMessageInput]);

  const filterOptions = createFilterOptions({
    trim: true,
  });

  const handleClose = () => {
    onClose();
    setAttachment(null);
    setSchedule(initialState);
    // ✅ MELHORIA: Reset do contato atual ao fechar
    setCurrentContact(initialContact);
    // Reset do dropdown de quickMessages
    setSelectedQuickMessage("");
    setQuickMessageSearch("");
    setShowAllQuickMessages(false);
    setFilteredQuickMessages([]);
    setQuickMessageMedia(null);
    setTemplateName("");
    setTemplateVariables({});
    setTemplateFile(null);
    setSchedule(prevState => ({
      ...prevState,
      reminderDate: "",
    }));
  };

  const handleAttachmentFile = (e) => {
    const file = head(e.target.files);
    if (file) {
      setAttachment(file);
    }
  };

  const handleDownloadTemplateXlsx = () => {
    const rows = [{
      "Nome do contato": currentContact?.name || "",
      "Parâmetro 1": "",
      "Valor 1": "",
    }];
    const ws = XLSX.utils.json_to_sheet(rows);
    ws["!cols"] = [{ wch: 30 }, { wch: 20 }, { wch: 30 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");
    XLSX.writeFile(wb, `template_agendamento_${templateName || "meta"}.xlsx`);
    toast.success("Template Excel gerado!");
  };

  const handleImportTemplateXlsx = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const wb = XLSX.read(evt.target.result, { type: "binary" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { defval: "" });
        if (rows.length === 0) { toast.error("Arquivo vazio."); return; }
        const row = rows[0];
        const variables = {};
        let n = 1;
        while (row[`Parâmetro ${n}`] !== undefined || row[`Parametro ${n}`] !== undefined) {
          const param = row[`Parâmetro ${n}`] || row[`Parametro ${n}`] || "";
          const val = row[`Valor ${n}`] || "";
          if (param) variables[param] = val;
          n++;
        }
        setTemplateVariables(variables);
        setTemplateFile(file);
        toast.success(`Variáveis carregadas: ${Object.keys(variables).length} parâmetro(s).`);
      } catch (err) {
        toast.error("Erro ao ler o arquivo Excel.");
      }
    };
    reader.readAsBinaryString(file);
    e.target.value = "";
  };

  const IconChannel = (channel) => {
    switch (channel) {
      case "facebook":
        return (
          <Facebook style={{ color: "#3b5998", verticalAlign: "middle" }} />
        );
      case "instagram":
        return (
          <Instagram style={{ color: "#e1306c", verticalAlign: "middle" }} />
        );
      case "whatsapp":
        return (
          <WhatsApp style={{ color: "#25d366", verticalAlign: "middle" }} />
        );
      default:
        return null;
    }
  };

  const renderOption = (option) => {
    return (
      <>
        {IconChannel(option.channel)}
        <Typography
          component="span"
          style={{
            fontSize: 14,
            marginLeft: "10px",
            display: "inline-flex",
            alignItems: "center",
            lineHeight: "2",
          }}
        >
          {getContactDisplayLabel(option)}
        </Typography>
      </>
    );
  };

  const handleSaveSchedule = async (values) => {
    // Validação de data: não pode ser no passado, mínimo 1 minuto à frente
    const sendAtMoment = moment(values.sendAt);
    const minDate = moment().add(1, "minute");
    if (!sendAtMoment.isValid()) {
      toast.error("Data de agendamento inválida.");
      return;
    }
    if (sendAtMoment.isBefore(minDate)) {
      toast.error("A data de agendamento deve ser pelo menos 1 minuto no futuro.");
      return;
    }

    if (!isOficialConnection && (!values.body || values.body.trim().length < 5)) {
      toast.error("Mensagem muito curta (mínimo 5 caracteres).");
      return;
    }
    if (isOficialConnection && !templateName.trim()) {
      toast.error("Informe o nome do template Meta aprovado.");
      return;
    }

    const scheduleData = {
      ...values,
      userId: user.id,
      whatsappId: selectedWhatsapps,
      ticketUserId: selectedUser?.id || null,
      queueId: selectedQueue || null,
      intervalo: intervalo || 1,
      tipoDias: tipoDias || 4,
      reminderDate: values.reminderDate || null,
      // Template Meta (API Oficial)
      templateName: isOficialConnection ? (templateName || null) : null,
      templateVariables: isOficialConnection && Object.keys(templateVariables).length > 0 ? templateVariables : null,
    };

    try {
      if (scheduleId) {
        await api.put(`/schedules/${scheduleId}`, scheduleData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/schedules/${scheduleId}/media-upload`, formData);
        }
      } else {
        const { data } = await api.post("/schedules", scheduleData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/schedules/${data.id}/media-upload`, formData);
        }
      }

      toast.success(i18n.t("scheduleModal.success"));

      if (typeof reload == "function") {
        reload();
      }

      if (contactId) {
        if (typeof cleanContact === "function") {
          cleanContact();
          history.push("/schedules");
        }
      }
    } catch (err) {
      toastError(err);
    }

    setCurrentContact(initialContact);
    setSchedule(initialState);
    // ✅ Reset dos campos de lembrete após salvar
    setSchedule(prevState => ({
      ...prevState,
      reminderDate: "",
    }));
    handleClose();
  };

  const handleClickMsgVar = async (msgVar, setValueFunc) => {
    const el = messageInputRef.current;
    const firstHalfText = el.value.substring(0, el.selectionStart);
    const secondHalfText = el.value.substring(el.selectionEnd);
    const newCursorPos = el.selectionStart + msgVar.length;

    setValueFunc("body", `${firstHalfText}${msgVar}${secondHalfText}`);

    await new Promise((r) => setTimeout(r, 100));
    messageInputRef.current.setSelectionRange(newCursorPos, newCursorPos);
  };

  // Função para lidar com seleção de resposta rápida
  const handleQuickMessageSelect = async (selectedMessage, setFieldValue) => {
    console.log("🎯 Mensagem selecionada:", selectedMessage);
    
    if (selectedMessage) {
      console.log("✅ Preenchendo campo body com:", selectedMessage.message);
      setFieldValue("body", selectedMessage.message || "");
      setQuickMessageSearch(selectedMessage.message || "");
      setShowAllQuickMessages(false);
      setQuickMessageListOpen(false);

      // Se a mensagem tem mídia, baixar e definir como attachment
      if (selectedMessage.mediaPath) {
        console.log("📎 Mensagem com mídia:", selectedMessage.mediaPath);

        try {
          const mediaFile = await downloadQuickMessageMedia(
            selectedMessage.mediaPath,
            selectedMessage.mediaName,
            selectedMessage.mediaType
          );

          if (mediaFile) {
            setAttachment(mediaFile);
            setQuickMessageMedia({
              path: selectedMessage.mediaPath,
              name: selectedMessage.mediaName,
              type: selectedMessage.mediaType
            });
            console.log("✅ Mídia da quickMessage definida como attachment:", mediaFile);
          }
        } catch (err) {
          console.error("❌ Erro ao processar mídia da quickMessage:", err);
        }
      } else {
        // Limpar mídia anterior se não há mídia na nova seleção
        setQuickMessageMedia(null);
        setAttachment(null);
        if (attachmentFile.current) {
          attachmentFile.current.value = null;
        }
      }
    }
  };

  const deleteMedia = async () => {
    if (attachment) {
      setAttachment(null);
      attachmentFile.current.value = null;
    }

    // Limpar mídia da quickMessage se existir
    if (quickMessageMedia) {
      setQuickMessageMedia(null);
    }

    if (schedule.mediaPath) {
      await api.delete(`/schedules/${schedule.id}/media-upload`);
      setSchedule((prev) => ({
        ...prev,
        mediaPath: null,
      }));
      toast.success(i18n.t("scheduleModal.toasts.deleted"));
      if (typeof reload == "function") {
        console.log(reload);
        console.log("1");
        reload();
      }
    }
  };

  return (
    <div className={classes.root}>
      <ConfirmationModal
        title={i18n.t("scheduleModal.confirmationModal.deleteTitle")}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={deleteMedia}
      >
        {i18n.t("scheduleModal.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      {currentContact?.id && (
        <ValidateContactListModal
          open={validateModalOpen}
          onClose={() => setValidateModalOpen(false)}
          contactIds={[currentContact.id]}
          sessionKey={`schedule-${scheduleId || "new"}`}
          whatsapps={whatsapps}
          onValidated={(result) => {
            // Mantém o Autocomplete sincronizado com o resultado (botão fica
            // vermelho se o contato não tiver WhatsApp de verdade).
            if (result.invalidItems?.some(i => i.id === currentContact.id)) {
              setCurrentContact(prev => ({ ...prev, isWhatsappValid: false }));
            } else {
              setCurrentContact(prev => ({ ...prev, isWhatsappValid: true }));
            }
          }}
        />
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">
          {schedule.status === "ERRO"
            ? "Erro de Envio"
            : `Mensagem ${capitalize(schedule.status)}`}
        </DialogTitle>
        <div style={{ display: "none" }}>
          <input
            type="file"
            accept=".png,.jpg,.jpeg"
            ref={attachmentFile}
            onChange={(e) => handleAttachmentFile(e)}
          />
        </div>
        <Formik
          initialValues={schedule}
          enableReinitialize={true}
          validationSchema={ScheduleSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveSchedule(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ touched, errors, isSubmitting, values, setFieldValue }) => (
            <Form>
              <DialogContent dividers>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6} xl={6}>
                    <div className={classes.multFieldLine} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <FormControl variant="outlined" fullWidth>
                        <Autocomplete
                          fullWidth
                          value={currentContact}
                          options={contacts}
                          onChange={(e, contact) => {
                            const contactId = contact ? contact.id : "";
                            setSchedule({ ...schedule, contactId });
                            setCurrentContact(contact ? contact : initialContact);
                            setChannelFilter(
                              contact ? contact.channel : "whatsapp"
                            );
                          }}
                          getOptionLabel={getContactDisplayLabel}
                          renderOption={renderOption}
                          getOptionSelected={(option, value) => {
                            return value.id === option.id;
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Contato"
                            />
                          )}
                        />
                      </FormControl>
                      {currentContact?.id && (
                        <IconButton
                          title="Validar se este contato tem WhatsApp"
                          size="small"
                          color={currentContact.isWhatsappValid === false ? "secondary" : "default"}
                          onClick={() => setValidateModalOpen(true)}
                        >
                          <VerifiedUserIcon />
                        </IconButton>
                      )}
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6} xl={6}>
                    <Field
                      as={TextField}
                      label={i18n.t("scheduleModal.form.sendAt")}
                      type="datetime-local"
                      name="sendAt"
                      error={touched.sendAt && Boolean(errors.sendAt)}
                      helperText={touched.sendAt && errors.sendAt}
                      variant="outlined"
                      fullWidth
                    />
                  </Grid>
                </Grid>
                {!isOficialConnection && (
                  <div className={classes.multFieldLine}>
                    <Field
                      as={TextField}
                      rows={9}
                      multiline={true}
                      label={i18n.t("scheduleModal.form.body")}
                      name="body"
                      inputRef={messageInputRef}
                      error={touched.body && Boolean(errors.body)}
                      helperText={touched.body && errors.body}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                    />
                  </div>
                )}

                {/* Campo de Busca de Respostas Rápidas */}
                {!isOficialConnection && (
                  <ClickAwayListener onClickAway={() => setQuickMessageListOpen(false)}>
                  <div className={classes.multFieldLine}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    label={i18n.t("ticketInfo.quickMessages")}
                    placeholder="Digite para buscar respostas rápidas..."
                    value={quickMessageSearch}
                    onChange={(e) => {
                      setQuickMessageSearch(e.target.value);
                      setQuickMessageListOpen(true);
                      if (e.target.value.trim() === "") {
                        setShowAllQuickMessages(false);
                      }
                    }}
                    onFocus={() => {
                      setQuickMessageListOpen(true);
                      if (quickMessageSearch.trim() === "" && !showAllQuickMessages) {
                        setShowAllQuickMessages(true);
                      }
                    }}
                    onClick={() => {
                      setQuickMessageListOpen(true);
                      if (quickMessageSearch.trim() === "" && !showAllQuickMessages) {
                        setShowAllQuickMessages(true);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Escape") {
                        setQuickMessageListOpen(false);
                      }
                    }}
                    disabled={loadingQuickMessages}
                    InputProps={{
                      startAdornment: <FlashOn style={{ marginRight: '8px', color: '#1976d2' }} />,
                    }}
                  />

                  {/* Lista de sugestões */}
                  {quickMessageListOpen && ((quickMessageSearch && filteredQuickMessages.length > 0) || (showAllQuickMessages && filteredQuickMessages.length > 0)) && (
                    <div style={{ 
                      maxHeight: '200px', 
                      overflowY: 'auto', 
                      border: '1px solid #e0e0e0', 
                      borderRadius: '4px', 
                      marginTop: '4px',
                      backgroundColor: 'white',
                      zIndex: 1000,
                      position: 'relative'
                    }}>
                      {filteredQuickMessages.map((quickMessage) => (
                        <div
                          key={quickMessage.id}
                          onClick={() => handleQuickMessageSelect(quickMessage, setFieldValue)}
                          style={{
                            padding: '12px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #f0f0f0',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                        >
                          <FlashOn style={{ fontSize: '16px', color: '#1976d2' }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                              {quickMessage.shortcode}
                            </div>
                            <div style={{ 
                              fontSize: '12px', 
                              color: '#666', 
                              maxWidth: '300px', 
                              overflow: 'hidden', 
                              textOverflow: 'ellipsis', 
                              whiteSpace: 'nowrap' 
                            }}>
                              {quickMessage.message}
                            </div>
                          </div>
                          {quickMessage.mediaPath && (
                            <AttachFile style={{ fontSize: '14px', color: '#666' }} />
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  
                  {/* Mensagem quando não há resultados */}
                  {quickMessageListOpen && quickMessageSearch && filteredQuickMessages.length === 0 && !loadingQuickMessages && (
                    <div style={{
                      padding: '12px',
                      textAlign: 'center',
                      color: '#666',
                      fontStyle: 'italic',
                      border: '1px solid #e0e0e0',
                      borderRadius: '4px',
                      marginTop: '4px'
                    }}>
                      Nenhuma resposta rápida encontrada
                    </div>
                  )}
                  </div>
                  </ClickAwayListener>
                )}

                {!isOficialConnection && <Grid item xs={12} md={12} xl={12}>
                  <MessageVariablesPicker
                    disabled={isSubmitting}
                    showSchedulingVars={true}
                    onClick={(value) => handleClickMsgVar(value, setFieldValue)}
                  />
                </Grid>}
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6} xl={3}>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="whatsapp-selection-label">
                        {i18n.t("campaigns.dialog.form.whatsapp")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.whatsapp")}
                        placeholder={i18n.t("campaigns.dialog.form.whatsapp")}
                        labelId="whatsapp-selection-label"
                        id="whatsappIds"
                        name="whatsappIds"
                        required
                        error={touched.whatsappId && Boolean(errors.whatsappId)}
                        value={selectedWhatsapps}
                        onChange={(event) =>
                          setSelectedWhatsapps(event.target.value)
                        }
                      >
                        {whatsapps &&
                          whatsapps.map((whatsapp) => (
                            <MenuItem key={whatsapp.id} value={whatsapp.id}>
                              {whatsapp.name}
                            </MenuItem>
                          ))}
                      </Field>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={12} xl={3}>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="openTicket-selection-label">
                        {i18n.t("campaigns.dialog.form.openTicket")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.openTicket")}
                        placeholder={i18n.t("campaigns.dialog.form.openTicket")}
                        labelId="openTicket-selection-label"
                        id="openTicket"
                        name="openTicket"
                        error={touched.openTicket && Boolean(errors.openTicket)}
                      >
                        <MenuItem value={"enabled"}>
                          {i18n.t("campaigns.dialog.form.enabledOpenTicket")}
                        </MenuItem>
                        <MenuItem value={"disabled"}>
                          {i18n.t("campaigns.dialog.form.disabledOpenTicket")}
                        </MenuItem>
                      </Field>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid spacing={1} container>
                  <Grid item xs={12} md={6} xl={4}>
                    <Autocomplete
                      style={{ marginTop: "8px" }}
                      variant="outlined"
                      margin="dense"
                      className={classes.formControl}
                      getOptionLabel={(option) => `${option.name}`}
                      value={isAdmin ? selectedUser : user}
                      size="small"
                      onChange={(e, newValue) => {
                        if (isAdmin) {
                          setSelectedUser(newValue);
                          if (newValue != null && Array.isArray(newValue.queues)) {
                            if (newValue.queues.length === 1) {
                              setSelectedQueue(newValue.queues[0].id);
                            }
                            setQueues(newValue.queues);
                          } else {
                            setQueues(allQueues);
                            setSelectedQueue("");
                          }
                        }
                      }}
                      options={isAdmin ? options : [user]}
                      filterOptions={filterOptions}
                      forcePopupIcon
                      freeSolo={isAdmin}
                      fullWidth
                      disabled={values.openTicket === "disabled" || !isAdmin}
                      autoHighlight
                      noOptionsText={i18n.t("transferTicketModal.noOptions")}
                      loading={loading}
                      renderOption={(option) => (
                        <span>
                          {" "}
                          <UserStatusIcon user={option} /> {option.name}
                        </span>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={i18n.t("transferTicketModal.fieldLabel")}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                            readOnly: !isAdmin, // Modo somente leitura se não for admin
                          }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} md={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="queue-selection-label" shrink={Boolean(selectedQueue)}>
                        {i18n.t("transferTicketModal.fieldQueueLabel")}
                      </InputLabel>
                      <Select
                        labelId="queue-selection-label"
                        value={selectedQueue || ""}
                        onChange={(e) => setSelectedQueue(e.target.value)}
                        label={i18n.t("transferTicketModal.fieldQueueLabel")}
                        notched={Boolean(selectedQueue)}
                        disabled={values.openTicket === "disabled"}
                      >
                        {queues.map((queue) => (
                          <MenuItem key={queue.id} value={queue.id}>
                            {queue.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid spacing={1} container alignItems="center" style={{ marginTop: "-10px" }}>
                  <Grid item xs={12} md={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="statusTicket-selection-label">
                        {i18n.t("campaigns.dialog.form.statusTicket")}
                      </InputLabel>
                      <Field
                        as={Select}
                        disabled={values.openTicket === "disabled"}
                        label={i18n.t("campaigns.dialog.form.statusTicket")}
                        placeholder={i18n.t(
                          "campaigns.dialog.form.statusTicket"
                        )}
                        labelId="statusTicket-selection-label"
                        id="statusTicket"
                        name="statusTicket"
                        error={
                          touched.statusTicket && Boolean(errors.statusTicket)
                        }
                      >
                        <MenuItem value={"closed"}>
                          {i18n.t("campaigns.dialog.form.closedTicketStatus")}
                        </MenuItem>
                        <MenuItem value={"open"}>
                          {i18n.t("campaigns.dialog.form.openTicketStatus")}
                        </MenuItem>
                      </Field>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6} xl={6}>
                    <FormControlLabel
                      control={
                        <Field
                          as={Switch}
                          color="primary"
                          name="assinar"
                          checked={values.assinar}
                          disabled={values.openTicket === "disabled"}
                        />
                      }
                      label={i18n.t("scheduleModal.form.assinar")}
                    />
                  </Grid>
                </Grid>
                {/* Seção de Template Meta (API Oficial) */}
                {isOficialConnection && (
                  <Grid container spacing={1} style={{ marginTop: 16, padding: "16px", backgroundColor: "#f0f4ff", borderRadius: 8, border: "1px solid #c5cae9" }}>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#3f51b5", marginBottom: 8 }}>
                        📋 Template Meta (API Oficial)
                      </Typography>
                      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
                        Informe o nome do template aprovado na Meta e, se necessário, carregue as variáveis via Excel.
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Nome do template Meta"
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={templateName}
                        onChange={(e) => setTemplateName(e.target.value)}
                        placeholder="Ex: meu_template_aprovado"
                      />
                    </Grid>
                    <Grid item xs={12} md={6} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleDownloadTemplateXlsx}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Baixar template Excel
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={() => templateFileRef.current.click()}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {templateFile ? `✅ ${templateFile.name}` : "Importar variáveis (.xlsx)"}
                      </Button>
                      <input
                        type="file"
                        accept=".xlsx,.xls"
                        ref={templateFileRef}
                        style={{ display: "none" }}
                        onChange={handleImportTemplateXlsx}
                      />
                    </Grid>
                    {Object.keys(templateVariables).length > 0 && (
                      <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary">
                          Variáveis carregadas: {Object.entries(templateVariables).map(([k, v]) => `${k} = "${v}"`).join(" | ")}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                )}

                <br />
                <h3>{i18n.t("recurrenceSection.title")}</h3>
                <p>{i18n.t("recurrenceSection.description")}</p>
                <br />
                <Grid container spacing={1}>
                  <Grid item xs={12} md={4} xl={4}>
                    <FormControl size="small" fullWidth variant="outlined">
                      <InputLabel id="demo-simple-select-label">
                        {i18n.t("recurrenceSection.labelInterval")}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={intervalo}
                        onChange={(e) => setIntervalo(e.target.value || 1)}
                        label={i18n.t("recurrenceSection.labelInterval")}
                      >
                        <MenuItem value={1}>
                          {i18n.t("recurrenceSection.options.days")}
                        </MenuItem>
                        <MenuItem value={2}>
                          {i18n.t("recurrenceSection.options.weeks")}
                        </MenuItem>
                        <MenuItem value={3}>
                          {i18n.t("recurrenceSection.options.months")}
                        </MenuItem>
                        <MenuItem value={4}>
                          {i18n.t("recurrenceSection.options.minutes")}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={4} xl={4}>
                    <Field
                      as={TextField}
                      label={i18n.t("recurrenceSection.intervalFilterValue")}
                      name="valorIntervalo"
                      type="number"
                      inputProps={{ min: 0 }}
                      size="small"
                      error={
                        touched.valorIntervalo && Boolean(errors.valorIntervalo)
                      }
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={4} xl={4}>
                    <Field
                      as={TextField}
                      label={i18n.t("recurrenceSection.sendAsManyTimes")}
                      name="enviarQuantasVezes"
                      type="number"
                      inputProps={{ min: 1 }}
                      size="small"
                      error={
                        touched.enviarQuantasVezes &&
                        Boolean(errors.enviarQuantasVezes)
                      }
                      variant="outlined"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={12} xl={12}>
                    <FormControl size="small" fullWidth variant="outlined">
                      <InputLabel id="demo-simple-select-label">
                        {i18n.t("recurrenceSection.sendAsManyTimes")}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={tipoDias}
                        onChange={(e) => setTipoDias(e.target.value || 4)}
                        label="Enviar quantas vezes"
                      >
                        <MenuItem value={4}>
                          {i18n.t(
                            "recurrenceSection.shipNormallyOnNonbusinessDays"
                          )}
                        </MenuItem>
                        <MenuItem value={5}>
                          {i18n.t("recurrenceSection.sendOneBusinessDayBefore")}
                        </MenuItem>
                        <MenuItem value={6}>
                          {" "}
                          {i18n.t("recurrenceSection.sendOneBusinessDayLater")}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                {(schedule.mediaPath || attachment || quickMessageMedia) && (
                  <Grid xs={12} item>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Button startIcon={<AttachFile />}>
                        {attachment ? attachment.name :
                          quickMessageMedia ? quickMessageMedia.name :
                            schedule.mediaName}
                      </Button>
                      {quickMessageMedia && (
                        <Chip
                          label="Da Resposta Rápida"
                          size="small"
                          color="primary"
                          variant="outlined"
                        />
                      )}
                      <IconButton
                        onClick={() => setConfirmationOpen(true)}
                        color="secondary"
                      >
                        <DeleteOutline color="secondary" />
                      </IconButton>
                    </div>
                  </Grid>
                )}
              </DialogContent>
              <DialogActions>
                {!attachment && !schedule.mediaPath && !quickMessageMedia && (
                  <Button
                    color="primary"
                    onClick={() => attachmentFile.current.click()}
                    disabled={isSubmitting}
                    variant="outlined"
                  >
                    {i18n.t("quickMessages.buttons.attach")}
                  </Button>
                )}
                <Button
                  onClick={handleClose}
                  color="secondary"
                  disabled={isSubmitting}
                  variant="outlined"
                >
                  {i18n.t("scheduleModal.buttons.cancel")}
                </Button>
                {(schedule.sentAt === null || schedule.sentAt === "") && (
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting}
                    variant="contained"
                    className={classes.btnWrapper}
                  >
                    {scheduleId
                      ? `${i18n.t("scheduleModal.buttons.okEdit")}`
                      : `${i18n.t("scheduleModal.buttons.okAdd")}`}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                )}
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};

export default ScheduleModal;